<template>
  <section class="hero">
    <div class="hero-inner container">
      <div class="hero-text">
        <WelcomeBack/>
        <h1>THE SUN HERO PROGRAM</h1>
        <p class="mb-2rem">
          Look! Up in the sky! It's a bird! It's a plane! It's actually the sun...and it can be problematic. </p>
        <p class="mb-2rem">
          <strong>Sun damage in childhood</strong> is one of the <strong>leading factors of skin cancer</strong>
          development in adulthood. Currently, too many children are exposed to dangerous levels of UV radiation because
          of poor sun safety habits, including inadequate use of sunscreen. </p>
        <p>Are you ready to help us do something about it?</p>
        <p class="mb-2rem">
          <a href="#howitworks" class="bold hero-callout">The world needs a Sun Hero.</a>
        </p>
        <SuperHeroCtaMobile/>
        <p class="footnote">Verified US healthcare professionals only.</p>
      </div>
      <div class="sun-hero-image">
        <img src="@/assets/images/global/Super-Steph-SunHero-300-V1.png" alt=""/>
      </div>
    </div>
  </section>
</template>
<script>
import WelcomeBack from '../elements/welcome/WelcomeBack.vue'
import SuperHeroCtaMobile from '../elements/buttons/SuperHeroCtaMobile.vue'

export default {
  components: {
    SuperHeroCtaMobile,
    WelcomeBack
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: unset;
}

.hero {
  position: relative;
  background-image: url("~@/assets/images/global/burst-left.png");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    background-image: none;
  }

  & > div {
    z-index: 12;
  }

  &:before {
    background-image: url("~@/assets/images/global/burst-right.png");
    background-size: auto 100%;
    background-position: right center;
    background-repeat: no-repeat;
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      background-image: none;
    }
  }

  .sun-hero-image {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 30%;
    left: 74%;
    @media screen and (max-width: 990px) {
      display: none;
    }

    img {
      width: 285px;
      height: auto;
    }
  }

  .hero-inner {
    display: flex;
    flex-flow: column wrap;
    align-content: space-around;
    padding-top: .clampedW(8, @md-bp, @large-bp) [ @result];
    padding-bottom: 0;
    @media screen and (max-width: ~"@{mq-xs-bp}") {
      padding-bottom: 6rem;
    }

    .hero-text {
      margin-top: 10rem;

      .hero-callout {
        color: @color-dk-orange;
        font-weight: 700;
        text-decoration: underline;
        @media screen and (max-width: ~"@{mq-md-bp}em") {
          color: @color-txt-blue;
          text-decoration: none;
        }
      }

      .mb-2rem {
        margin-bottom: 2rem;
      }
    }

    h1 {
      font-size: 60px;
      text-align: left;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        margin-top: 30px;
        font-size: 45px;
        text-align: center;
      }
    }

    h1,
    div,
    p {
      // flex: 0 1 100%;
    }

    p {
      font-size: 18px;
      width: 70%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        width: 100%;
      }

      &.footnote {
        // font-size: .clampedW(2, @md-bp, @large-bp) [ @result];
        font-size: 10px;
        line-height: 1.2;
        // padding: 0 25%;
        padding-bottom: 2%;
        @media screen and (max-width: ~"@{mq-md-bp}em") {
          font-size: 12px;
          padding-bottom: 5%;
          // display: none;
        }
      }
    }

    .show-br-mobile {
      @media screen and (max-width: 900px) {
        display: block;
      }
    }

    .width-60 {
      width: 60%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        width: 100%;
      }
    }

    .width-50 {
      width: 50%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        width: 100%;
      }
    }
  }
}
</style>
